<template>
	<span class="tool-group"><tool-item v-for="item in group.items" :key="item.id" :item="item" @action="replayAction"></tool-item></span>
</template>

<script setup lang="ts">
import ToolItem from "@/ui/toolbar/ToolItem.vue";
import {ToolbarGroup} from "@t/ui/Toolbar.ts";

defineProps<{
	group: ToolbarGroup
}>();
const emit = defineEmits(["action"]);

function replayAction(id: string, arg?: any) {
	emit("action", id, arg);
}

</script>

<style>
.tool-group {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: baseline;

	&:empty {
		display: none;
	}
}
</style>